<script setup lang="ts">
import { ref, onMounted } from "vue";
import { utc2local } from "@/utils";
import { usePromotionStore } from "@/stores/promotions";
import { storeToRefs } from "pinia";
const listloaded = ref(false);
const promotions = usePromotionStore();
const { campaignCodes } = storeToRefs(promotions);

onMounted(async () => {
  await promotions.getCampaigns();
  listloaded.value = true;
});
</script>

<template>
  <h2>
    Currently active campaigns
    <span v-show="listloaded">({{ campaignCodes.length }})</span>
  </h2>
  <pn-spinner size="4" v-show="!listloaded" />

  <pn-table bordered="true" striped="true" v-show="listloaded">
    <table>
      <thead>
        <tr>
          <th>Code</th>
          <th>Valid until</th>
          <th>Created by</th>
          <th>Created date</th>
          <th>Free cards</th>
          <th>Usage limit</th>
          <th>Login required</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="code in campaignCodes" :key="code.id">
          <td>{{ code.code }}</td>
          <td>{{ utc2local(code.expireAt) }}</td>
          <td>{{ code.createdBy }}</td>
          <td>{{ utc2local(code.createdAt) }}</td>
          <td>{{ code.value }}</td>
          <td>{{ code.usageLimit }}</td>
          <td>{{ code.requireLogin ? "Yes" : "No" }}</td>
        </tr>
      </tbody>
    </table>
  </pn-table>
</template>
